// Put here your own Custom JS codes

function setActiveCategory() {
  document.querySelectorAll('#filter-collapse-categories .nav-link').forEach(function(link) {
    if (window.location.pathname === link.getAttribute('href')) {
      link.classList.add('active-category');
    }
  });
}

setActiveCategory();

// Watch entire page body for Shopify AJAX filter updates
new MutationObserver(function() {
  setActiveCategory();
}).observe(document.body, { childList: true, subtree: true });

/*
    Price decimals — show the cents smaller and raised (e.g. €116,⁹⁵).
    Wraps the 2 decimal digits of every .product-price-final / .product-price-compare
    in <span class="price-decimals">. A MutationObserver re-applies it automatically
    when prices are rewritten (variant change, AJAX collection filtering, etc.).
*/
;(() => {
    const PRICE_RE = /([.,])(\d{2})(?=\D*$)/

    const stylePriceEl = ($el) => {
        if ($el.querySelector('.price-decimals')) return
        const walker = document.createTreeWalker($el, NodeFilter.SHOW_TEXT)
        let node
        while ((node = walker.nextNode())) {
            const m = node.nodeValue.match(PRICE_RE)
            if (!m) continue
            const tail = node.splitText(m.index)  // tail starts at the separator
            tail.splitText(m[0].length)           // tail is now exactly separator + 2 digits
            const span = document.createElement('span')
            span.className = 'price-decimals'
            span.textContent = m[2]
            tail.nodeValue = m[1]                 // keep the separator full-size
            tail.parentNode.insertBefore(span, tail.nextSibling)
            break
        }
    }

    const styleAll = () => {
        document.querySelectorAll('.product-price-final, .product-price-compare, .price-final, #cart-subtotal-value').forEach(stylePriceEl)
    }

    let scheduled = false
    const observer = new MutationObserver(() => {
        if (scheduled) return
        scheduled = true
        requestAnimationFrame(() => { scheduled = false; styleAll() })
    })

    const init = () => {
        styleAll()
        observer.observe(document.body, { childList: true, subtree: true })
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init)
    } else {
        init()
    }
})()
